<template>
  <v-card>
    <main>
      <img
        src="@/assets/images/Dialog/EligibilityLoading/monkey.png"
        alt="monkey-hanging"
        class="animal"
      />
      <h1 class="dialog-title text-bold">{{ title }}</h1>
      <v-progress-circular
        indeterminate
        color="accent"
        :size="49"
        :width="8"
      ></v-progress-circular>
      <section
        class="defaqto-banner"
        :class="{ 'ma-5 alert-info': !imageSource }"
        :style="{
          backgroundColor: backgroundMessageColor,
          'border-width': borderWidth,
          'border-style': borderStyle,
          'border-color': borderColor,
          'border-radius': borderRadius,
        }"
      >
        <img
          v-if="imageSource"
          :src="imageSource"
          alt="Defaqto 5-star Expert Rated"
        />
        <v-icon v-if="!imageSource" color="var(--blue-500)"
          >mdi-information</v-icon
        >
        <p class="ma-0">
          {{ gettingQuoteMessage }}
        </p>
      </section>
    </main>
  </v-card>
</template>

<script>
import { GETTING_QUOTE_HOME_MESSAGE } from "@/constants/message.constants";

export default {
  name: "EligibilityLoading",
  props: {
    title: {
      type: String,
      required: true,
    },
    gettingQuoteMessage: {
      type: String,
      required: false,
      default: GETTING_QUOTE_HOME_MESSAGE,
    },
    imageSource: {
      type: String,
      default: require("@/assets/images/defaqto/home-2024.png"),
    },
    backgroundMessageColor: {
      type: String,
      default: "#f8f8f8",
    },
    borderWidth: {
      type: String,
      default: "",
    },
    borderStyle: {
      type: String,
      default: "",
    },
    borderColor: {
      type: String,
      default: "",
    },
    borderRadius: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
main {
  min-height: 200px;
  overflow: hidden;
  position: relative;
  text-align: center;

  .animal {
    display: block;
    position: absolute;
    right: 0px;
    top: 0px;
  }

  .defaqto-banner {
    align-items: center;
    display: flex;
    text-align: left;

    img {
      display: block;
    }
  }

  .alert-info {
    align-items: flex-start !important;
    .v-icon {
      margin: 3px 10px 0px 4px;
    }
    p {
      line-height: 22px;
    }
  }

  .banner {
    display: block;
    max-width: 100%;
  }
}

// xs breakpoint
@media screen and (max-width: 600px) {
  main {
    .animal {
      height: 132px;
      right: -28px;
      width: 141px;
    }

    .dialog-title {
      margin-left: 12px;
      max-width: 200px;
      padding-top: 35px;
      position: relative;
      text-align: left;
      z-index: 10;
    }

    .v-progress-circular {
      margin: 46px 0;
    }

    .defaqto-banner {
      font-size: 16px;
      padding: 20px 12px;

      img {
        height: 50px;
        margin-right: 15px;
        width: 117px;
      }
    }
  }
}

// sm breakpoint
@media screen and (min-width: 600px) and (max-width: 960px) {
  main {
    .animal {
      height: 162px;
      width: 171px;
      z-index: 5;
    }

    .dialog-title {
      margin-left: auto;
      margin-right: auto;
      max-width: 304px;
      padding-top: 35px;
      position: relative;
      z-index: 10;
    }

    .v-progress-circular {
      margin: 76px 0;
    }

    .defaqto-banner {
      font-size: 16px;
      padding: 20px 12px;

      img {
        height: 76px;
        margin-right: 15px;
        width: 117px;
      }
    }
  }
}

// sm breakpoint plus
@media screen and (min-width: 960px) {
  main {
    .animal {
      height: 218px;
      width: 230px;
    }

    .dialog-title {
      padding-top: 62px;
    }

    .v-progress-circular {
      margin: 98px 0;
    }

    .defaqto-banner {
      font-size: 18px;
      padding: 27px 45px 29px 40px;

      img {
        height: 90px;
        margin-right: 23px;
        width: 138px;
      }
    }

    .alert-info {
      padding: 24px 16px;
    }
  }
}
</style>
